interface RGBObject {
	r: number,
	g: number,
	b: number
}

// Misc color helper functions
export function rgbStringToObject(rgb: string): RGBObject | null {
	const match = rgb?.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
	if (!match || !match.length)
		return null;

	const [, r, g, b] = match;
	return { r: parseInt(r, 10), g: parseInt(g, 10), b: parseInt(b, 10) };
}

export function rgbToHex(rgb: string): string | null {
	// put the RGB values in an array
	const result = rgb?.match(/\d+/g)?.map(Number);
	if (!result || !result.length)
		return null;
	// convert them from decimal to hex, add leading 0s if needed
	return '#' + result.map((val) => val.toString(16).padStart(2, '0')).join('').toUpperCase();
}

export function mixRGB(color1: string | RGBObject, color2: string | RGBObject, weight = 0.5): string | null {
	if (!color1 || !color2)
		return null;

	const rgb1 = typeof color1 === 'string' ? rgbStringToObject(color1) : color1;
	const rgb2 = typeof color2 === 'string' ? rgbStringToObject(color2) : color2;

	if (!rgb1 || !rgb2)
		return null;

	const r = Math.round(rgb1.r * weight + rgb2.r * (1 - weight));
	const g = Math.round(rgb1.g * weight + rgb2.g * (1 - weight));
	const b = Math.round(rgb1.b * weight + rgb2.b * (1 - weight));

	return `rgb(${r},${g},${b})`;
}